import React, {Component} from "react";
import {compose} from "redux";
import {connect} from "react-redux";
import {deleteProjectPhoto, getProjectPhoto, uploadProjectPhoto} from "../../actions/photos";
import * as PropTypes from "prop-types";
import NotFound from "../cProject-not-found.png";
import {withTransparentLoading} from "./deferLoaderHoc";
import {Button, Card} from "antd";
import {canUpdate} from "./permissions";

class DocumentPhoto extends Component {
  handleUpload(files) {
    const { onUpload, onDelete, photo: { datecreated = null } = {} } = this.props;
    let queuedFiles = Array.from(files);
    if (!queuedFiles.length) return;
    if (datecreated && onDelete) onDelete();
    if (onUpload) onUpload(queuedFiles);
  }

  handleUploadClick = () => {
    this.uploadRef.current.click();
  };

  handleDelete = () => {
    const { onDelete } = this.props;
    if (onDelete) onDelete();
  };

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  constructor(props) {
    super(props);
    this.uploadRef = React.createRef();
  }

  render() {
    const { photo: { url = null, datecreated = null } = {}, project } = this.props;
    return <Card title='Project Photo' extra={
      canUpdate(project) && <div className='bid-dashboard-controls'>
        {datecreated && <Button icon='delete' onClick={this.handleDelete}>
          <span className='hidden inline visible-xxl'>Delete</span>
        </Button>}
        <Button icon='upload' onClick={this.handleUploadClick}>
          <span className='hidden inline visible-xxl'>Upload</span>
          <input style={{ display: 'none' }} type='file' ref={this.uploadRef} accept='image/*'
                 onChange={e => this.handleUpload(e.target.files)}/>
        </Button>
      </div>
    }>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className='bid-dashboard-photo'>
          <div style={{backgroundImage: `url('${url ? url : NotFound}')`}}/>
        </div>
      </div>
    </Card>;
  }
}

DocumentPhoto.propTypes = { id: PropTypes.any };

export default compose(
  connect(
    (state, props) => ({
      photo: state.photos.data[props.id],
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getProjectPhoto({ id: props.id })),
      onUpload: photo => dispatch(uploadProjectPhoto(props.id, photo)),
      onDelete: () => dispatch(deleteProjectPhoto({ id: props.id })),
    }),
  ),
  withTransparentLoading,
)(DocumentPhoto)


// WEBPACK FOOTER //
// ./src/components/Boilerplate/DocumentPhoto.js